export const useDataFromHash = () => {
    const hashData = window.location.hash.replace("#", "");
    const amount = hashData.replace(/.*amount=([0-9.]+).*/, '$1');
    const recurring = hashData.includes('recurring');

    return {amount, recurring};
}
